import { restockBinSources } from "@redotech/redo-return-core-common/restock-bin-source";
import * as z from "zod";

export const getReturnRestockBins = {
  name: "getReturnRestockBins" as const,
  input: z.object({}),
  output: z.object({
    source: z.enum(restockBinSources).nullable(),
    bins: z.array(z.string()),
  }),
};

export type GetReturnRestockBinsOutput = z.infer<
  typeof getReturnRestockBins.output
>;
